import Vue from 'vue';
import { Store, } from './index';

export async function checkUserDetails() {
	if (Store.state.userDetails) {
		return;
	}

	const { result: customerDetails, } = await Vue.selfServeApi.customerDetailsBasicDetailsList();
	Store.commit.updateCustomerDetails(customerDetails);
	callConcurrentApis(customerDetails.contractAccounts[0]);
}

function callConcurrentApis(contractAccountId: string) {
	checkContractAccountDetails(contractAccountId);
	checkContractPropertyDetails(contractAccountId);
	checkClientMeterList(contractAccountId);
	checkSwitchAccountDetails(contractAccountId);
}

export function checkContractAccountDetails(contractAccountId: string) {
	if (Store.state.contractAccountDetails.state === 'completed') {
		return;
	}

	void Store.dispatch.updateContractAccountDetails(contractAccountId);
}

export function checkContractPropertyDetails(contractAccountId: string) {
	if (Store.state.contractPropertyDetails.state === 'completed') {
		return;
	}

	void Store.dispatch.updateContractPropertyDetails(contractAccountId);
}

export function checkClientMeterList(conractAccountId: string) {
	if (Store.state.contractClientMeterDetails.state === 'completed') {
		return;
	}

	void Store.dispatch.updateClientMeterList(conractAccountId);
}

export function checkSwitchAccountDetails(conractAccountId: string) {
	if (Store.state.switchAccountDetails.state === 'completed') {
		return;
	}
	void Store.dispatch.updateSwitchAccountDetails(conractAccountId);
}
